import { Button, Text, useKumoToastManager } from '@cloudflare/kumo'
import { CopyIcon } from '@phosphor-icons/react'
import { useTranslation } from '../../i18n'

// The M365 shared mailbox polled by crons/emailPoll.ts.
export const PRINT_EMAIL = 'print@tesset.com'

/** "Or email the PDF to print@tesset.com" with a 44x44 copy button. */
export function PrintByEmail() {
  const { t } = useTranslation()
  const toasts = useKumoToastManager()

  async function copy() {
    try {
      await navigator.clipboard.writeText(PRINT_EMAIL)
      toasts.add({ variant: 'success', title: t('printCenter.byEmail.copied') })
    } catch {
      toasts.add({ variant: 'error', title: t('common.errorTitle') })
    }
  }

  return (
    <div className="flex items-center justify-between gap-3">
      <div className="min-w-0">
        <Text variant="secondary">{t('print.send.emailLabel')}</Text>
        <span style={{ overflowWrap: 'anywhere', minWidth: 0 }}>
          <Text variant="mono" DANGEROUS_className="font-medium">
            {PRINT_EMAIL}
          </Text>
        </span>
      </div>
      <Button
        variant="secondary"
        shape="square"
        icon={<CopyIcon size={18} />}
        aria-label={t('print.send.copyEmail')}
        style={{ width: 44, height: 44 }}
        className="shrink-0"
        type="button"
        onClick={() => void copy()}
      />
    </div>
  )
}
